
import React from 'react';
import { Drawer } from 'antd';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import Helpers from '@Apis/helpers';

const PRZDrawer = ({
  open,
  onClose,
  title,
  children,
  width = 1030,
  headerWidth = 980,
  destroyOnClose = true,
  mask = true,
}) => (
  <Drawer
    open={open}
    onClose={onClose}
    width={Helpers.getDrawerWidth(width)}
    destroyOnClose={destroyOnClose}
    mask={mask}
  >
    <div className="custom-drawer__header-wrapper">
      <div className="custom-drawer__header" style={{ width: Helpers.getDrawerWidth(headerWidth) }}>
        <H3Text text={title} className="custom-drawer__title" />
        <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={onClose} />
      </div>
    </div>
    {children}
  </Drawer>
);

export default PRZDrawer;
